<template>
  <div class="widget">
    <div class="widget-heading align-items-center">
      <h2>{{ $t("registration.training") }}</h2>
      <button
        class="btn btnStyle btn-primary btnDownloadTrainingSheet"
        v-tooltip="{ title: this.$t('registration.download_training_sheet') }"
        v-if="$route.params.registration"
        @click="downloadTrainingSheet"
      >
        <FontAwesomeIcon icon="fa-light fa-file-download" />
      </button>
    </div>
    <div class="widget-content">
      <div v-if="group?.trainingCourse?.training?.name" class="item">
        <span class="item__title">{{ $t("registration.name") }} :</span><br />
        {{ group.trainingCourse.training.name
        }}<router-link
          v-if="group?.trainingCourse?.training?.id"
          v-access:[permissions]="{
            access: accessConstante.ALL,
            code: accessConstante.STUDEA_MANAGER_REGISTRATION_DASHBOARD,
          }"
          v-tooltip="{ title: $t('registration.dashboard.go_to') }"
          :to="{ name: 'TrainingDashboard', params: { trainingId: group?.trainingCourse?.training?.id } }"
          target="_blank"
          class="btn btn-icon"
          ><FontAwesomeIcon icon="fa-light fa-arrow-up-right-from-square"
        /></router-link>
      </div>
      <div v-if="group?.trainingCourse?.training?.institution?.name" class="item">
        <span class="item__title">{{ $t("registration.institution") }} :</span><br />
        {{ group.trainingCourse.training.institution.name }}
      </div>
      <div v-if="group?.trainingCourse?.training?.component?.name" class="item">
        <span class="item__title">{{ $t("registration.component") }} :</span><br />
        {{ group.trainingCourse.training.component.name }}
      </div>
      <div v-if="group?.startYeat || group?.endYear" class="item">
        <span class="item__title">{{ $t("registration.trainingCourse") }} :</span><br />
        {{ group?.startYear }} -
        {{ group?.endYear }}
      </div>
      <div v-if="group?.name" class="item">
        <span class="item__title">{{ $t("registration.group") }} :</span><br />
        {{ group.name }}
        <router-link
          v-if="group?.cryptedId"
          v-access:[permissions]="{
            access: accessConstante.ALL,
            code: accessConstante.STUDEA_MANAGER_REGISTRATION_DASHBOARD,
          }"
          v-tooltip="{ title: $t('registration.group_action.see_group_detail') }"
          :to="{ name: 'RegistrationGroupEdit', params: { id: group?.cryptedId } }"
          target="_blank"
          class="btn btn-icon"
          ><FontAwesomeIcon icon="fa-light fa-arrow-up-right-from-square"
        /></router-link>
      </div>
      <div
        v-if="
          group?.trainingCourse?.training?.trainingContact?.name ||
          group?.trainingCourse?.training?.trainingContact?.email ||
          group?.trainingCourse?.training?.trainingContact?.phone ||
          group?.trainingCourse?.training?.trainingContact?.additionalInformation
        "
        class="item"
      >
        <div v-if="group?.trainingCourse?.training?.trainingContact?.name">
          <span class="item__title">{{ $t("registration.Contact") }} :</span><br />
          {{ $t("lastName") }} : {{ group.trainingCourse.training.trainingContact.name }}
        </div>
        <div v-if="group?.trainingCourse?.training?.trainingContact?.email">
          {{ $t("email") }} : {{ group?.trainingCourse.training.trainingContact.email }}
        </div>
        <div v-if="group?.trainingCourse?.training?.trainingContact?.phone">
          {{ $t("phone") }} : {{ group.trainingCourse.training.trainingContact.phone }}
        </div>
        <div v-if="group?.trainingCourse?.training?.trainingContact?.additionalInformation">
          {{ $t("complement") }} : {{ group.trainingCourse.training.trainingContact.additionalInformation }}
        </div>
      </div>
    </div>
  </div>

  <div class="widget">
    <div class="widget-heading">
      <h2 class="textStyle">{{ $t("registration.pedagogicInformations") }}</h2>
    </div>
    <div class="widget-content">
      <div class="item">
        <span class="item__title">{{ $t("registration.dates") }} :</span><br />
        <span v-if="group?.startDate">
          {{ $t("dashboard.contract.from") + " " + dateFormatter().format(group.startDate, "short") }} </span
        ><br />
        <span v-if="group?.endDate">
          {{ $t("dashboard.contract.to") + " " + dateFormatter().format(group.endDate, "short") }}
        </span>
      </div>
      <div v-if="group?.hourlyTrainingVolume" class="item">
        <span class="item__title">{{ $t("registration.hourlyVolume") }} :</span><br />
        {{ group.hourlyTrainingVolume }} h
      </div>
      <div v-if="group?.hourlyRemoteTeachingVolume" class="item">
        <span class="item__title">{{ $t("registration.remoteVolume") }} :</span><br />
        {{ group.hourlyRemoteTeachingVolume }} h
      </div>
      <div>
        <div v-if="group?.training?.titleRncp?.name" class="item">
          <span class="item__title">{{ $t("registration.degreePrepared") }} :</span><br />
          {{ group.training.titleRncp.name }}
        </div>
        <div v-if="group?.training?.titleRncp?.level" class="item">
          <span class="item__title">{{ $t("registration.level") }} :</span><br />
          {{ group.training.titleRncp.level }}
        </div>
        <div v-if="group?.training?.titleRncp?.code" class="item">
          <span class="item__title">{{ $t("registration.titleRncp") }} :</span><br />
          {{ group.training.titleRncp.code }}
        </div>
      </div>
      <div v-if="group?.trainingCourse?.training?.degreeCode" class="item">
        <span class="item__title">{{ $t("registration.degreeCode") }} :</span><br />
        {{ group.trainingCourse.training.degreeCode }}
      </div>
      <div class="mt-2">
        <a v-if="group?.calendar" class="btn btn-success btnStyle d-block w-100" :href="getFileSrc(group?.calendar)">
          <FontAwesomeIcon icon="fa-light fa-calendar" class="me-1" />
          {{ $t("registration.calendar") }}
        </a>
        <a v-if="group?.program" class="btn btn-success btnStyle d-block mt-2 w-100" :href="getFileSrc(group?.program)">
          <FontAwesomeIcon icon="fa-light fa-list" class="me-1" />
          {{ $t("registration.program") }}
        </a>
      </div>
    </div>
  </div>
  <div v-if="displayFundingInformations()" class="widget">
    <div class="widget-heading">
      <h2 class="textStyle">{{ $t("registration.fundingInformations") }}</h2>
    </div>
    <div class="widget-content">
      <div v-if="group?.trainingCost12month && group?.totalTrainingCost">
        <h6>
          {{ $t("registration.privateSector") }}
        </h6>
        <div class="item">
          <span class="item__title">{{ $t("registration.annualRate") }} :</span><br />
          {{ stringManager().formatCurrency(group?.trainingCost12month) }}
        </div>
        <div class="item">
          <span class="item__title">{{ $t("registration.totalRate") }} :</span><br />
          {{ stringManager().formatCurrency(group?.totalTrainingCost) }}
        </div>
      </div>

      <div v-if="group?.publicTrainingCost12month && group?.totalPublicTrainingCost" class="mt-4">
        <h6>
          {{ $t("registration.publicSector") }}
        </h6>
        <div class="item">
          <span class="item__title">{{ $t("registration.annualRate") }} :</span><br />
          {{ stringManager().formatCurrency(group?.publicTrainingCost12month) }}
        </div>
        <div class="item">
          <span class="item__title">{{ $t("registration.totalRate") }} :</span><br />
          {{ stringManager().formatCurrency(group?.totalPublicTrainingCost) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFormatter } from "@/services/utilities/date-formatter";
import { fileManager } from "@/services/file/file-manager";
import { stringManager } from "@/services/utilities/string-manager";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { accessConstante } from "@/constantes/access";
import { mapState } from "pinia";
import { useUserStore } from "@/store/user/user";

export default {
  name: "RegistrationInformationsComponent",
  components: { FontAwesomeIcon },
  emits: ["downloadTrainingSheet"],
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  computed: {
    accessConstante() {
      return accessConstante;
    },

    ...mapState(useUserStore, {
      permissions: (store) => store.permissions,
    }),
  },
  methods: {
    stringManager() {
      return stringManager;
    },
    dateFormatter() {
      return dateFormatter;
    },

    getFileSrc(file) {
      return fileManager.getDownloadSrc(file);
    },

    downloadTrainingSheet() {
      this.$emit("downloadTrainingSheet");
    },

    displayFundingInformations() {
      return (
        (this.group?.trainingCost12month && this.group?.totalTrainingCost) ||
        (this.group?.publicTrainingCost12month && this.group?.totalPublicTrainingCost)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.item + .item {
  border-top: 1px dashed $m_color_6;
  padding-top: 5px;
  margin-top: 5px;
}

.item {
  &__title {
    font-weight: 700;
    color: var(--primary-color);
    @include dark-theme {
      color: $white;
    }
  }
}

.btn-icon {
  svg {
    width: 10px;
    height: 10px;
  }
}
</style>
